/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component } from '@angular/core';
import { NbLoginComponent } from '@nebular/auth';
import { jwtVerify, SignJWT } from 'jose';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends NbLoginComponent {
  user: any = { password: '' };

  async onPasswordBlur() {
    if (this.user.password) {
      const secretKey = new TextEncoder().encode(this.user.password);
      const jwt = await new SignJWT({ password: this.user.password })
        .setProtectedHeader({ alg: 'HS256' }) // HMAC SHA-256 Algorithm
        .setExpirationTime('1h')
        .sign(secretKey);

      this.user.Encodedpassword = 'web:'+jwt;
    }
  }
}
